import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-32 bg-[#050505] relative z-10 border-t border-white/5" data-id="element-27">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-29">
          <h2 className="font-display text-4xl md:text-5xl text-white mb-8 tracking-tight leading-[1.0] text-balance" data-id="element-30">
            Built for the Next Era of <br className="hidden md:block" data-id="element-31" />
            <span className="text-gray-500" data-id="element-32">Industry Software.</span>
          </h2>

          <p className="font-body text-lg md:text-xl text-gray-400 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-33">
            Aijentik exists to create AI products that do more than converse. We
            build vertical intelligence that understands real-world workflows,
            business logic, compliance, and actionability. Our focus is simple:
            create AI that is genuinely useful in the industries where execution
            matters.
          </p>
        </motion.div>
      </div>
    </section>;
}